<!-- <cx-page-slot id="account-nav" position="HeaderLinks"></cx-page-slot> -->

<div style="min-height: 50vh">
  <div *ngIf="quoteId; else noId">
    <quotes-history-details></quotes-history-details>
  </div>

  <ng-template #noId>
    <div><quotes-history-form></quotes-history-form></div>
  </ng-template>
</div>
